/**
 * Disable some filters at initialization
 *
 * @param {ValueType[]} values filter values
 * @param {boolean[]} initiallyEnabled array of enabled/disabled filters
 * @returns {ValueType[]}
 */
function filterInitiallyEnabled(values, initiallyEnabled) {
    return initiallyEnabled
        ? values.filter(function (_value, index) { return initiallyEnabled[index]; })
        : values;
}
/**
 * Initialize structure of filters
 *
 * @param {string} columns columns of data
 * @param {Object} filterConfigs static configuration
 * @returns {Object}
 */
export function initializeFilters(columns, filterConfigs) {
    return columns.reduce(function (acc, col) {
        var conf = filterConfigs[col];
        // @ts-ignore
        acc[col] = conf
            ? filterInitiallyEnabled(conf.values, conf.initiallyEnabled)
            : ['']; // no configuration => defaulting to single value string filter
        return acc;
    }, {});
}
/**
 * Filter function for filtering rows by string
 *
 * @param {Object} row object
 * @param {Object} filters filter object
 * @returns {boolean} returned value for Array.filter
 */
export function filterFunction(row, filters) {
    return Object.entries(filters)
        .every(function (_a) {
        var filterCol = _a[0], filterValues = _a[1];
        var columnValue = row[filterCol];
        if (typeof columnValue === 'string' && filterValues.some(function (filterValue) { return columnValue.toLowerCase().includes(filterValue.toLowerCase()); })) {
            return true;
        }
        if (typeof columnValue === 'number' || typeof columnValue === 'boolean') {
            // filter values could arrive as strings
            // empty string => no filter
            if (filterValues.length === 1 && filterValues[0] === '') {
                return true;
                // tslint:disable-next-line: triple-equals
            }
            else if (filterValues.some(function (filterValue) { return columnValue == filterValue; })) {
                return true;
            }
        }
        return false;
    });
}
/**
 * Check if is all filters in default state
 *
 * @param {Object} filters filter object
 * @param {Object} filterConfigs static filter configuration
 * @returns {boolean}
 */
export function isAllFiltersDefaulted(filters, filterConfigs) {
    return Object.entries(filters)
        .every(function (_a) {
        var filterCol = _a[0], filterValues = _a[1];
        var filterConfigValues = filterConfigs[filterCol];
        if (!filterConfigValues) {
            // no config -> filterValues are defaulted to empty string
            return filterValues[0] === '';
        }
        else if (filterConfigValues.values.every(function (configValue, i) {
            var initiallyEnabled = filterConfigValues.initiallyEnabled
                ? filterConfigValues.initiallyEnabled[i] // some can be disabled
                : true; // default enabled
            var found = filterValues.includes(configValue);
            // initiallyEnabled = true should be found in filters, initiallyEnabled = false should not be found in filters
            return found === initiallyEnabled;
        })) {
            return true;
        }
        return false;
    });
}
/**
 * Comparator function for sorting
 *
 * @param {Object} a first object
 * @param {Object} b second object
 * @param {string} orderBy column to be compared
 * @returns {number}
 */
export function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
/**
 * Check if the children structure is present and renderable
 *
 * @param {Object} children to be checked
 * @returns {boolean}
 */
export function isRenderableChildren(children) {
    if (children && Array.isArray(children) && children.length) {
        return true;
    }
    return false;
}
/**
 * Convert value to string
 *
 * @param {string | number | boolean} value to be converted
 * @returns {string} converted value
 */
export function convertToString(value, booleanDisplayTranslator) {
    switch (typeof value) {
        case 'string':
            return value;
        case 'number':
            return "" + value;
        case 'boolean':
            return translateValue(value, booleanDisplayTranslator);
        default:
            return null;
    }
}
export function translateValue(value, filterConfig) {
    return filterConfig.display[filterConfig.values.indexOf(value)];
}
/**
 * Split array of IdRecords by ids into two new arrays
 *
 * @param {T[]} data array of IdRecords
 * @param {IdType[]} ids array of IdType used for splitting
 * @returns { match: T[], rest: T[]} object of splitted arrays
 */
export function splitArrayById(data, ids) {
    var match = [];
    var rest = [];
    data.forEach(function (row) {
        if (ids.includes(row.id)) {
            match.push(row);
        }
        else {
            rest.push(row);
        }
    });
    return { match: match, rest: rest };
}
/**
 * difference of IdRecords
 *
 * @param {T[]} data array of IdRecords
 * @param {T[]} other array of IdRecords
 * @returns {T[]} rows of data not included in other
 */
export function idRecordDifference(data, other) {
    var rightIds = other.map(function (_a) {
        var id = _a.id;
        return id;
    });
    return data.filter(function (row) { return rightIds.every(function (rightId) { return rightId !== row.id; }); });
}
//# sourceMappingURL=utils.js.map